import React, { Component } from 'react';
import PropTypes from 'prop-types';

import config from 'cityads-v3/config';

const insertedForLocale = {};
const loadedForLocale = {};
let insertedLocale = null;
let loadedLocale = null;
let initedAppId = null;
let callbacks = [];

function insertFacebookSDKScript(locale, appId, callback) {
  (function(d, s, id){
    var js;
    var fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = `https://connect.facebook.net/${locale}/sdk.js`;
    js.onload = function () {
      loadedForLocale[locale] = true;
      loadedLocale = locale;
    };
    fjs.parentNode.insertBefore(js, fjs);

    insertedForLocale[locale] = true;
    insertedLocale = locale;

    callbacks = [callback];
    initAsyncInit(locale, appId);
  }(document, 'script', 'facebook-jssdk'));
}

function initAsyncInit(locale, appId) {
  if (!window) { return; }

  window.fbAsyncInit = function () {
    if (loadedLocale !== locale) { return; }

    syncInit(appId);

    callbacks.forEach(cb => cb(window.FB));
  };
}

function syncInit(appId) {
  if (!window) { return; }

  window.FB.init({
    appId            : appId,
    autoLogAppEvents : true,
    xfbml            : false,
    version          : 'v2.12'
  });

  initedAppId = appId;
}

export class FacebookSDKProvider extends Component {
  static propTypes = {
    children: PropTypes.func,
    locale  : PropTypes.string,
    appId   : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }

  state = {
    FB: null
  }

  componentDidMount() {
    const { locale, appId } = this.props;

    if (insertedLocale === locale) {
      if (loadedLocale === locale) {
        if (initedAppId !== appId) {
          syncInit(appId);
        }

        this.setState({ FB: window && window.FB });
      } else {
        callbacks.push(FB => this.setState({ FB }));
      }
    } else {
      insertFacebookSDKScript(locale, appId, FB => this.setState({ FB }));
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const { locale, appId } = this.props;

    if (insertedLocale === locale) {
      if (loadedLocale === locale) {
        if (initedAppId !== appId) {
          syncInit(appId);

          this.setState({ FB: window && window.FB });
        }
      } else {
        callbacks.push(FB => this.setState({ FB }));
      }
    } else {
      insertFacebookSDKScript(locale, appId, FB => this.setState({ FB }));
    }
  }

  render() {
    const { children } = this.props;

    if (typeof children === 'function') {
      return children(this.state.FB);
    }

    return children;
  }
}

export default class DefaultFacebookSDKProvider extends Component {
  render() {
    return (
      <FacebookSDKProvider
        locale = "en_US"
        appId  = {config.FB_APP_ID}
        {...this.props}
      />
    );
  }
}
